module.exports = __webpack_public_path__ + "static/media/cachablau.3d811bf1.jpg";